import axios from 'axios';
import typeToReducer from 'type-to-reducer';
import { SUCCESS, REQUEST, FAIL } from 'containers/App/configureStore';
import { url } from 'configs/';
import fieldCodes from '../../../configs/fieldCodes';
const baseUrl = url.NEWTUBE_API_SERVER;
const path = 'tube/peoplesearch/';
const FETCH_PEOLPLESEARCH_FIELDSETTINGS = `${path}FETCH_PEOLPLESEARCH_FIELDSETTINGS`;

// 依表單參數判斷是否顯示
const isDisplayField = (fieldName) => (fieldSettings) => (component) => {
  if (Object.keys(fieldSettings).length === 0) {
    return null;
  }
  const isFieldDisplay = fieldSettings[fieldCodes[fieldName]].isDisplay;
  if (component) {
    // 如果是，則給default component
    return isFieldDisplay ? component : null;
  }
  return isFieldDisplay;
};

export const isDisplayExtensionNumber = isDisplayField('extensionNumber'); // 是否顯示分機
export const isDisplayBusinessMobileNumber = isDisplayField('businessMobileNumber'); // 是否顯示公司手機
export const isDisplayBusinessEmail = isDisplayField('businessEmail'); // 是否顯示公司信箱

const initialState = {
  fieldSettings: {},
  isLoading: true,
  isLoaded: true,
};

export default typeToReducer({
  [FETCH_PEOLPLESEARCH_FIELDSETTINGS]: {
    [REQUEST]: (state) => {
      return Object.assign({}, state, { isLoading: true, isLoaded: false, fieldSettings: {} });
    },
    [SUCCESS]: (state, action) => {
      const newData = {};
      action.payload.data.data.forEach((baseField) => {
        newData[baseField.fieldCode] = {
          fieldCode: baseField.fieldCode,
          fieldName: baseField.fieldSetting.aliases,
          isDisplay: baseField.fieldSetting.isDisplay,
          required: baseField.fieldSetting.required,
        };
      });
      return Object.assign({}, state, {
        isLoading: false,
        isLoaded: true,
        fieldSettings: newData,
      });
    },
    [FAIL]: (state) => {
      return Object.assign({}, state, { isLoading: false, isLoaded: false, fieldSettings: {} });
    },
  },
}, initialState);

/*
  以myteam參數設定取得參數設定: 0410 公司信箱、0420 分機、0430 公務手機
*/
export function fetchPeopleSearchFieldSettings() {
  return {
    type: FETCH_PEOLPLESEARCH_FIELDSETTINGS,
    payload: axios.get(`${baseUrl}fieldsettings/mydata`),
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/PeopleSearch/reducers/fieldsReducer.js
 **/